import { WritableDraft } from 'immer';

import { Speaker } from '@/types/speakers.types';
import { SpeakersState } from '../types';

const upsertSpeakerById = (speaker: Speaker, state: WritableDraft<SpeakersState>) => {
  state.speakersById[speaker.speaker] = speaker;
};

export default upsertSpeakerById;
